import { render, staticRenderFns } from "./SkillCard.vue?vue&type=template&id=40fde558&scoped=true"
import script from "./SkillCard.vue?vue&type=script&lang=js"
export * from "./SkillCard.vue?vue&type=script&lang=js"
import style0 from "./SkillCard.vue?vue&type=style&index=0&id=40fde558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fde558",
  null
  
)

export default component.exports